import React from 'react'
import './about.css'
import ME from '../../assets/1.png'
import {BsAward} from 'react-icons/bs'
import {AiFillCode} from 'react-icons/ai'
import {VscFolderOpened} from 'react-icons/vsc'

const about = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About Image"/>
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
          <article className='about__card'>
              <BsAward className='about__icon'/>
              <h5>Experience</h5>
              <small>
                SDE Intern at Amazon - Successfully completed Internship and my projects were shipped to prod.
              </small>
            </article>
            <article className='about__card'>
              <BsAward className='about__icon'/>
              <h5>Experience</h5>
              <small>
                1.5 years Experience as software developer at NTT data
              </small>
            </article>
            <article className='about__card'>
              <AiFillCode className='about__icon'/>
              <h5>Algorithms and DS</h5>
              <small>
                500+ problems solved
              </small>
            </article>
            <article className='about__card'>
              <VscFolderOpened className='about__icon'/>
              <h5>Education</h5>
              <small>
                Currently Pursuing MS in Software Engineering from San Jose State University.
              </small>
            </article>
          </div>
          <p>
          I am a self driven computer science enthusiast, and I believe in hard work. My area of interest lies in FullStack Development, Machine learning and Neural Networks. I am an avid coder and really like working with data structures and algorithms. I am looking to work in the software domain where I can put my skills to use and make a difference. At the same time I am willing to put in all my effort to do whatever it takes to achieve my goals.
          </p>
          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default about
